<!-- Displays a submitted birth date chat answer as a formatted date. -->

<script lang="ts" setup>
import { computed } from 'vue';

import { useDateFormat } from '@sigma/client/i18n/useDateFormat.js';
import type { BirthDateInputValue } from '@sigma/common/forms/BirthDateInput.js';

interface Props {
  /** The birth date answer value to display. */
  value: BirthDateInputValue;
}

const props = defineProps<Props>();

const formatDate = useDateFormat();
const formattedDate = computed(() => formatDate(props.value.date, 'shortDate'));
</script>

<template>
  {{ formattedDate }}
</template>
